/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// The Google Maps JS library can only be loaded once per page, otherwise it throws an error.
// This utility function allows multiple apps to try to load the library and get notified when the library has been loaded.

const MAP_PROXY_CHANNEL = 'layout-service'; // This is for tracking purposes only.
const MAP_PROXY_HOST_NA = 'https://mapproxy.groupon.com';
const MAP_PROXY_HOST_EU = 'https://mapproxy-eu.groupon.com';

const GOOGLE_MAPS_VERSION = 3;
const GOOGLE_MAPS_LIBRARIES = ['geometry']; // Check the Google Maps docs for details on libraries available.

let loading = false;
const callbacks = [];

function loaded() {
  return callbacks.map(cb => {
    cb();
  });
}

function getMapProxyHost(country) {
  // Based on https://github.groupondev.com/itier-service-clients/itier-groupon-v2-client/blob/master/src/base_url.coffee
  return country === 'US' ? MAP_PROXY_HOST_NA : MAP_PROXY_HOST_EU;
}

module.exports = {
  load(cb) {
    if (typeof cb !== 'function') {
      cb = function() {};
    }

    if (window.google && window.google.maps) {
      cb();
      return;
    }
    callbacks.push(cb);

    if (loading) {
      return;
    }

    loading = true;

    const callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;

    const { country, lang } = document.head.dataset;

    const params = new URLSearchParams({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: country || 'US',
      language: lang || 'en',
      channel: MAP_PROXY_CHANNEL,
    });

    const s = document.createElement('script');
    s.src = `${getMapProxyHost(country)}/maps/api/js?${params.toString()}`;
    s.onerror = () => cb('Unable to load Google Maps Library');
    document.body.appendChild(s);
  },
};
